
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 36 36"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "选择对象"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "select",
        "style": "isolation:isolate"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "select-2",
            "data-name": "select"
          },
          "children": [
            {
              "tag": "polygon",
              "attrsMap": {
                "points": "12 8 12 28 18 22 26 22 12 8",
                "style": "fill:#c7d4e8;fill-rule:evenodd"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  